import { useState, useEffect } from 'react';
import api from '../api/client';

export default function ContactLists() {
  const [lists, setLists] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [contacts, setContacts] = useState([]);
  const [addingTo, setAddingTo] = useState(null);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [contactSearch, setContactSearch] = useState('');
  const [existingMemberIds, setExistingMemberIds] = useState([]);

  // Import modal state
  const [showImport, setShowImport] = useState(false);
  const [importName, setImportName] = useState('');
  const [importDesc, setImportDesc] = useState('');
  const [importFile, setImportFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);

  const fetchLists = () => {
    api.get('/contact-lists').then((res) => setLists(res.data));
  };

  useEffect(() => { fetchLists(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    await api.post('/contact-lists', { nombre, descripcion });
    setNombre(''); setDescripcion(''); setShowForm(false);
    fetchLists();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminar esta lista?')) return;
    await api.delete(`/contact-lists/${id}`);
    fetchLists();
  };

  const handleImport = async (e) => {
    e.preventDefault();
    if (!importFile || !importName) return;
    setImporting(true);
    setImportResult(null);
    try {
      const formData = new FormData();
      formData.append('file', importFile);
      formData.append('nombre', importName);
      formData.append('descripcion', importDesc);
      const res = await api.post('/contact-lists/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setImportResult({ success: true, data: res.data });
      fetchLists();
    } catch (err) {
      const error = err.response?.data?.error || 'Error al importar';
      const detail = err.response?.data?.detail;
      setImportResult({ success: false, error: detail ? `${error}: ${detail}` : error });
    }
    setImporting(false);
  };

  const closeImport = () => {
    setShowImport(false);
    setImportName('');
    setImportDesc('');
    setImportFile(null);
    setImportResult(null);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1>Listas de contactos</h1>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => setShowImport(true)} style={{
            padding: '8px 20px', background: '#3498db', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer',
          }}>Importar Excel/CSV</button>
          <button onClick={() => setShowForm(!showForm)} style={{
            padding: '8px 20px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer',
          }}>{showForm ? 'Cancelar' : '+ Nueva Lista'}</button>
        </div>
      </div>

      {showForm && (
        <form onSubmit={handleCreate} style={{ background: '#fff', borderRadius: 8, padding: 20, marginBottom: 20, display: 'flex', gap: 10 }}>
          <input placeholder="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} required
            style={{ flex: 1, padding: 10, border: '1px solid #ddd', borderRadius: 4 }} />
          <input placeholder="Descripcion (opcional)" value={descripcion} onChange={(e) => setDescripcion(e.target.value)}
            style={{ flex: 2, padding: 10, border: '1px solid #ddd', borderRadius: 4 }} />
          <button type="submit" style={{ padding: '10px 20px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Crear</button>
        </form>
      )}

      {/* Import Modal */}
      {showImport && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={(e) => { if (e.target === e.currentTarget) closeImport(); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 30, width: 480, maxHeight: '80vh', overflow: 'auto' }}>
            <h2 style={{ margin: '0 0 20px' }}>Crear lista desde archivo</h2>

            {!importResult?.success ? (
              <form onSubmit={handleImport}>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontWeight: 600, marginBottom: 4, fontSize: 13 }}>Nombre de la lista *</label>
                  <input value={importName} onChange={(e) => setImportName(e.target.value)} required placeholder="Ej: Top 100 Ventas"
                    style={{ width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 4, boxSizing: 'border-box' }} />
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontWeight: 600, marginBottom: 4, fontSize: 13 }}>Descripcion (opcional)</label>
                  <input value={importDesc} onChange={(e) => setImportDesc(e.target.value)} placeholder="Ej: Clientes con mas compras"
                    style={{ width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 4, boxSizing: 'border-box' }} />
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontWeight: 600, marginBottom: 4, fontSize: 13 }}>Archivo CSV o Excel *</label>
                  <input type="file" accept=".csv,.xlsx,.xls" onChange={(e) => setImportFile(e.target.files[0])}
                    style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 4, boxSizing: 'border-box' }} />
                  <p style={{ fontSize: 12, color: '#888', margin: '6px 0 0' }}>
                    Columnas requeridas: <strong>nombre</strong>, <strong>telefono</strong> (formato +525512345678)
                    <br />Opcional: <strong>email</strong>
                  </p>
                </div>

                {importResult?.success === false && (
                  <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 6, padding: 12, marginBottom: 14, color: '#dc2626', fontSize: 13 }}>
                    {importResult.error}
                  </div>
                )}

                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <button type="button" onClick={closeImport} style={{
                    padding: '10px 20px', border: '1px solid #ddd', borderRadius: 4, background: '#fff', cursor: 'pointer',
                  }}>Cancelar</button>
                  <button type="submit" disabled={importing || !importFile || !importName} style={{
                    padding: '10px 20px', background: '#3498db', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer',
                    opacity: (importing || !importFile || !importName) ? 0.5 : 1,
                  }}>{importing ? 'Importando...' : 'Crear lista'}</button>
                </div>
              </form>
            ) : (
              <div>
                <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 6, padding: 16, marginBottom: 16 }}>
                  <div style={{ fontWeight: 700, color: '#16a34a', fontSize: 15, marginBottom: 8 }}>
                    Lista "{importResult.data.list.nombre}" creada
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: 22, fontWeight: 700, color: '#4ecca3' }}>{importResult.data.contacts.addedToList}</div>
                      <div style={{ fontSize: 11, color: '#888' }}>En la lista</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: 22, fontWeight: 700, color: '#3498db' }}>{importResult.data.contacts.created}</div>
                      <div style={{ fontSize: 11, color: '#888' }}>Nuevos</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: 22, fontWeight: 700, color: '#f59e0b' }}>{importResult.data.contacts.updated}</div>
                      <div style={{ fontSize: 11, color: '#888' }}>Actualizados</div>
                    </div>
                  </div>
                  {importResult.data.errors > 0 && (
                    <div style={{ marginTop: 10, fontSize: 12, color: '#dc2626' }}>
                      {importResult.data.errors} contactos con errores (telefono invalido)
                    </div>
                  )}
                  {importResult.data.contacts.skippedNoWhatsapp > 0 && (
                    <div style={{ marginTop: 10, fontSize: 12, color: '#856404' }}>
                      {importResult.data.contacts.skippedNoWhatsapp} contactos omitidos por no tener WhatsApp (detectado en envíos previos)
                    </div>
                  )}
                </div>
                <div style={{ textAlign: 'right' }}>
                  <button onClick={closeImport} style={{
                    padding: '10px 20px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer',
                  }}>Listo</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {lists.map((l) => (
          <div key={l.id} style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h3 style={{ margin: 0 }}>{l.nombre}</h3>
              <button onClick={() => handleDelete(l.id)} style={{
                background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: 13,
              }}>Eliminar</button>
            </div>
            {l.descripcion && <p style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>{l.descripcion}</p>}
            <div style={{ fontSize: 24, fontWeight: 700, color: '#4ecca3' }}>{l.contactCount}</div>
            <div style={{ fontSize: 12, color: '#888' }}>contactos</div>
            <button onClick={async () => {
              if (!window.confirm(`Validar todos los números de "${l.nombre}" contra Twilio Lookup?\n\n• Marca como "sin WA" los teléfonos fijos\n• Costo aproximado: $${(l.contactCount * 0.005).toFixed(2)} USD (1 lookup = $0.005)\n• Solo valida los que aún no se han verificado\n\n¿Continuar?`)) return;
              try {
                const { data } = await api.post('/contacts/validate-twilio', { listId: l.id, skipAlreadyChecked: true });
                alert(data.message);
                fetchLists();
              } catch (err) {
                alert(err.response?.data?.error || 'Error al validar');
              }
            }} style={{
              marginTop: 6, padding: '6px 14px', background: '#fff', color: '#f39c12', border: '1px solid #f39c12',
              borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 6,
            }}>🔍 Validar con Twilio</button>
            <button onClick={async () => {
              setAddingTo(l.id);
              setContactSearch('');
              // Fetch existing members to exclude them
              const listRes = await api.get(`/contact-lists/${l.id}`);
              const existingIds = (listRes.data.Contacts || []).map((c) => c.id);
              const res = await api.get('/contacts?limit=1000');
              setContacts(res.data.contacts.filter((c) => !existingIds.includes(c.id)));
              setSelectedContacts([]);
              setExistingMemberIds(existingIds);
            }} style={{
              marginTop: 10, padding: '6px 14px', background: '#3498db', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12,
            }}>Agregar contactos</button>

            {addingTo === l.id && (
              <div style={{ marginTop: 10, background: '#f9f9f9', borderRadius: 4, padding: 10 }}>
                <input
                  placeholder="Buscar por nombre o telefono..."
                  value={contactSearch}
                  onChange={async (e) => {
                    const val = e.target.value;
                    setContactSearch(val);
                    const res = await api.get(`/contacts?limit=1000&search=${encodeURIComponent(val)}`);
                    setContacts(res.data.contacts.filter((c) => !existingMemberIds.includes(c.id)));
                  }}
                  style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 4, marginBottom: 8, boxSizing: 'border-box', fontSize: 12 }}
                />
                <div style={{ maxHeight: 250, overflowY: 'auto' }}>
                  {contacts.map((c) => {
                    const isNoWa = c.whatsapp_status === 'no_whatsapp';
                    return (
                    <label key={c.id} title={isNoWa ? 'Este contacto no tiene WhatsApp (detectado en envíos previos). Será omitido al agregarlo.' : ''}
                      style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 4, opacity: isNoWa ? 0.5 : 1 }}>
                      <input type="checkbox" checked={selectedContacts.includes(c.id)}
                        onChange={(e) => {
                          if (e.target.checked) setSelectedContacts([...selectedContacts, c.id]);
                          else setSelectedContacts(selectedContacts.filter((id) => id !== c.id));
                        }} />
                      {c.nombre} ({c.telefono})
                      {isNoWa && <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 8, background: '#f8d7da', color: '#721c24', marginLeft: 4 }}>sin WA</span>}
                      {c.whatsapp_status === 'valid' && <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 8, background: '#d4edda', color: '#155724', marginLeft: 4 }}>✓</span>}
                    </label>
                    );
                  })}
                  {contacts.length === 0 && <div style={{ fontSize: 12, color: '#888', padding: 8 }}>No se encontraron contactos</div>}
                </div>
                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                  <button onClick={async () => {
                    const { data } = await api.post(`/contact-lists/${l.id}/contacts`, { contactIds: selectedContacts });
                    if (data.skippedNoWhatsapp > 0) {
                      alert(data.message);
                    }
                    setAddingTo(null);
                    fetchLists();
                  }} disabled={selectedContacts.length === 0} style={{
                    padding: '6px 14px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12,
                    opacity: selectedContacts.length === 0 ? 0.5 : 1,
                  }}>Agregar ({selectedContacts.length})</button>
                  <button onClick={() => setAddingTo(null)} style={{
                    padding: '6px 14px', border: '1px solid #ddd', borderRadius: 4, background: '#fff', cursor: 'pointer', fontSize: 12,
                  }}>Cancelar</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
